/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/GoogleAnalyticsSettings', 'model/GoogleAnalyticsAccount'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/GoogleAnalyticsSettings'), require('../model/GoogleAnalyticsAccount'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.GoogleAnalyticsSettingsApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.GoogleAnalyticsSettings, root.ForStractionServiceApi.GoogleAnalyticsAccount);
  }
}(this, function(ApiClient, GoogleAnalyticsSettings, GoogleAnalyticsAccount) {
  'use strict';

  /**
   * GoogleAnalyticsSettings service.
   * @module api/GoogleAnalyticsSettingsApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new GoogleAnalyticsSettingsApi. 
   * @alias module:api/GoogleAnalyticsSettingsApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the googleAnalyticsSettingsAddPut operation.
     * @callback module:api/GoogleAnalyticsSettingsApi~googleAnalyticsSettingsAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/GoogleAnalyticsSettings} body 
     * @param {module:api/GoogleAnalyticsSettingsApi~googleAnalyticsSettingsAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.googleAnalyticsSettingsAddPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling googleAnalyticsSettingsAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling googleAnalyticsSettingsAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/GoogleAnalyticsSettings/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the googleAnalyticsSettingsCheckGoogleAnalyticsAuthenticationGet operation.
     * @callback module:api/GoogleAnalyticsSettingsApi~googleAnalyticsSettingsCheckGoogleAnalyticsAuthenticationGetCallback
     * @param {String} error Error message, if any.
     * @param {'Boolean'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * checkGoogleAnalyticsAuthentication
     * @param {String} _4SAPIAppID 
     * @param {module:api/GoogleAnalyticsSettingsApi~googleAnalyticsSettingsCheckGoogleAnalyticsAuthenticationGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Boolean'}
     */
    this.googleAnalyticsSettingsCheckGoogleAnalyticsAuthenticationGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling googleAnalyticsSettingsCheckGoogleAnalyticsAuthenticationGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Boolean';

      return this.apiClient.callApi(
        '/GoogleAnalyticsSettings/checkGoogleAnalyticsAuthentication', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the googleAnalyticsSettingsEditPut operation.
     * @callback module:api/GoogleAnalyticsSettingsApi~googleAnalyticsSettingsEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/GoogleAnalyticsSettings} body 
     * @param {Integer} primaryKey 
     * @param {module:api/GoogleAnalyticsSettingsApi~googleAnalyticsSettingsEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.googleAnalyticsSettingsEditPut = function(_4SAPIAppID, body, primaryKey, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling googleAnalyticsSettingsEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling googleAnalyticsSettingsEditPut";
      }

      // verify the required parameter 'primaryKey' is set
      if (primaryKey == undefined || primaryKey == null) {
        throw "Missing the required parameter 'primaryKey' when calling googleAnalyticsSettingsEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'primaryKey': primaryKey
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/GoogleAnalyticsSettings/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the googleAnalyticsSettingsGetGoogleAnalyticsAccountInformationGet operation.
     * @callback module:api/GoogleAnalyticsSettingsApi~googleAnalyticsSettingsGetGoogleAnalyticsAccountInformationGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/GoogleAnalyticsAccount>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * getGoogleAnalyticsAccountInformation
     * @param {String} _4SAPIAppID 
     * @param {module:api/GoogleAnalyticsSettingsApi~googleAnalyticsSettingsGetGoogleAnalyticsAccountInformationGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/GoogleAnalyticsAccount>}
     */
    this.googleAnalyticsSettingsGetGoogleAnalyticsAccountInformationGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling googleAnalyticsSettingsGetGoogleAnalyticsAccountInformationGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [GoogleAnalyticsAccount];

      return this.apiClient.callApi(
        '/GoogleAnalyticsSettings/getGoogleAnalyticsAccountInformation', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the googleAnalyticsSettingsLoadGet operation.
     * @callback module:api/GoogleAnalyticsSettingsApi~googleAnalyticsSettingsLoadGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/GoogleAnalyticsSettings} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * load
     * @param {String} _4SAPIAppID 
     * @param {module:api/GoogleAnalyticsSettingsApi~googleAnalyticsSettingsLoadGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/GoogleAnalyticsSettings}
     */
    this.googleAnalyticsSettingsLoadGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling googleAnalyticsSettingsLoadGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = GoogleAnalyticsSettings;

      return this.apiClient.callApi(
        '/GoogleAnalyticsSettings/load', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
